import { render, staticRenderFns } from "./tarifariosCRUD.vue?vue&type=template&id=ba6291f4&scoped=true"
import script from "./tarifariosCRUD.vue?vue&type=script&lang=js"
export * from "./tarifariosCRUD.vue?vue&type=script&lang=js"
import style0 from "./tarifariosCRUD.vue?vue&type=style&index=0&id=ba6291f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6291f4",
  null
  
)

export default component.exports